var _path, _path2, _path3, _path4, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNullTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    d: "M6 6h100v100H6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAED",
    d: "M16 16h100v100H16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M26 26h100v100H26z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#AECBFA",
    d: "M26 26h100v48H26z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 26,
    width: 100,
    height: 100
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M26 26h100v100H26z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-98.02 94.145c5.46 3.499 7.58 3.923 9.382 3.923 1.802 0 3.922-.424 9.382-3.923a11.13 11.13 0 0111.98 0c5.46 3.499 7.58 3.923 9.382 3.923 1.802 0 3.923-.424 9.383-3.923a11.13 11.13 0 0111.98 0c5.459 3.499 7.58 3.923 9.381 3.923 1.803 0 3.87-.424 9.277-3.87v-.053a11.141 11.141 0 016.308-1.75c.53 0 1.113.054 1.643.16 1.431.265 2.81.795 4.028 1.59 5.46 3.499 7.58 3.923 9.383 3.923 1.802 0 3.922-.424 9.382-3.923a11.13 11.13 0 0111.98 0c5.46 3.499 7.58 3.923 9.382 3.923 1.802 0 3.923-.424 9.382-3.923a11.13 11.13 0 0111.98 0c5.46 3.499 7.58 3.923 9.382 3.923 1.802 0 3.923-.424 9.383-3.923a10.865 10.865 0 017.845-1.59v10.124c-2.65-.477-5.46.053-7.845 1.591-5.46 3.498-7.58 3.922-9.383 3.922-1.802 0-3.922-.424-9.382-3.922a11.127 11.127 0 00-11.98 0c-5.46 3.498-7.58 3.922-9.382 3.922-1.802 0-3.922-.424-9.382-3.922a11.127 11.127 0 00-11.98 0c-5.46 3.498-7.58 3.922-9.382 3.922-1.803 0-3.923-.424-9.383-3.922a11.11 11.11 0 00-5.671-1.75c-2.174-.053-4.294.53-6.202 1.75-5.46 3.498-7.58 3.922-9.383 3.922-1.802 0-3.922-.424-9.382-3.922a11.127 11.127 0 00-11.98 0c-5.46 3.498-7.58 3.922-9.382 3.922-1.802 0-3.922-.424-9.382-3.922a11.127 11.127 0 00-11.98 0c-5.46 3.498-7.58 3.922-9.382 3.922-1.802 0-3.923-.424-9.382-3.922a11.127 11.127 0 00-11.98 0V94.145a10.922 10.922 0 0111.98 0z",
    fill: "#81C995"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.73 58.524a6.616 6.616 0 00-4.93-.159c-.477.159-.954.318-1.484.477l.424-.848c.477-.954.106-2.173-.848-2.65l-2.173 4.293c-2.545.636-5.089 1.06-7.74 1.22-6.201.424-12.297-.478-18.18-2.704l-2.704 7.156a50.808 50.808 0 0021.362 3.18c4.611-.318 9.117-1.219 13.464-2.756 1.961-.689 3.498-2.226 4.134-4.188l.689-2.067-2.014-.954z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.005 62.712a3.717 3.717 0 00-.53-3.976",
    stroke: "#3C4043",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.436 54.973c-4.294.265-8.481 1.113-12.51 2.438-2.332.742-4.187 2.544-5.141 4.77l-.742 1.803 3.02.848c1.644.477 3.34.424 4.984-.106a44.414 44.414 0 0110.866-2.173c6.202-.424 12.298.477 18.182 2.703l2.703-7.156c-6.891-2.544-14.047-3.605-21.362-3.127z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.477 49.142a6.678 6.678 0 007.262 0c3.286-2.12 4.559-2.386 5.672-2.386 1.06 0 2.385.266 5.671 2.386a6.678 6.678 0 007.262 0c3.287-2.12 4.559-2.386 5.672-2.386 1.06 0 2.386.266 5.672 2.386a6.678 6.678 0 007.262 0c3.286-2.12 4.559-2.386 5.672-2.386V34.46c-1.06 0-2.386-.265-5.672-2.386a6.678 6.678 0 00-7.262 0c-3.287 2.12-4.559 2.386-5.672 2.386-1.06 0-2.385-.265-5.672-2.386a6.678 6.678 0 00-7.262 0c-3.286 2.12-4.558 2.386-5.671 2.386-1.06 0-2.386-.265-5.672-2.386a6.678 6.678 0 00-7.262 0",
    fill: "#3C4043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.78 66.9L57.45 88.26l-19.772-5.778-2.756 6.255 22.104 9.647c3.87 1.697 8.428-.106 10.072-3.975l7.898-18.076L66.78 66.9zM81.463 54.654c5.566 0 10.124-4.505 10.124-10.124H71.391c-.053 5.619 4.506 10.124 10.072 10.124z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.463 34.459c-5.566 0-10.125 4.505-10.125 10.124h20.196c0-5.619-4.506-10.124-10.071-10.124z",
    fill: "#3C4043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.237 58.736a45.152 45.152 0 00-7.793-2.28l-3.392 7.58-6.202 13.995 16.91 7.368 4.505-15.531.583-2.545c.795-3.604-1.113-7.262-4.505-8.64-.106.106-.106.053-.106.053z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.956 77.872l-4.506 10.39 22.21 9.912 4.347-10.496-22.051-9.806z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.81 88.526l-1.803-.795-4.347 10.443-5.777 19.771 6.255 2.757 9.647-22.104c1.696-3.87-.106-8.376-3.976-10.072z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18.085 118.528c3.604-2.332 8.322-2.332 11.926 0 5.46 3.499 7.527 3.923 9.33 3.923 1.802 0 3.87-.424 9.329-3.923 3.605-2.332 8.322-2.332 11.927 0 5.46 3.499 7.527 3.923 9.329 3.923 1.802 0 3.87-.424 9.33-3.923 3.604-2.332 8.322-2.332 11.926 0 5.46 3.499 7.527 3.923 9.33 3.923h44.154",
    stroke: "#5F6368",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.757 62.34l-3.021 5.937c-.954-.477-1.378-1.696-.848-2.65l.742-1.431",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.9 110.418c0 6.785-5.513 12.298-12.298 12.298s-12.297-5.513-12.297-12.298 5.512-12.297 12.297-12.297c6.785 0 12.298 5.512 12.298 12.297z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 98,
    width: 25,
    height: 25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.9 110.418c0 6.785-5.513 12.298-12.298 12.298s-12.297-5.513-12.297-12.298 5.512-12.297 12.297-12.297c6.785 0 12.298 5.512 12.298 12.297z",
    fill: "#FBBC04"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)",
    stroke: "#5F6368",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.263 104.004a7.352 7.352 0 01-7.368 7.368 7.352 7.352 0 01-7.368-7.368 7.352 7.352 0 017.368-7.368c4.081 0 7.368 3.34 7.368 7.368zM126.413 104.004a7.352 7.352 0 01-7.368 7.368 7.352 7.352 0 01-7.368-7.368 7.352 7.352 0 017.368-7.368c4.081 0 7.368 3.34 7.368 7.368zM116.501 122.451a7.352 7.352 0 01-7.368 7.368 7.352 7.352 0 01-7.368-7.368 7.352 7.352 0 017.368-7.368 7.352 7.352 0 017.368 7.368z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNullTasks);
export default __webpack_public_path__ + "static/media/nullTasks.4d7c6bfc66927a1153f6f2ad389b9579.svg";
export { ForwardRef as ReactComponent };